import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminWaitlist() {
  const [groups, setGroups] = useState([]);
  const [open, setOpen] = useState(null);
  const load = () => api.get("/admin/waitlist").then((r) => setGroups(r.data));
  useEffect(() => { load(); }, []);
  const notify = async (pid) => {
    if (!window.confirm("Kirim email 'drop rilis' ke semua subscriber pending?")) return;
    const { data } = await api.post(`/admin/waitlist/${pid}/notify`);
    toast.success(`${data.sent}/${data.total_pending} email terkirim`);
    load();
  };
  return (
    <div>
      <h1 className="display text-4xl md:text-6xl mb-6">WAITLIST</h1>
      {groups.length === 0 ? <div className="text-neutral-500 text-sm">Belum ada waitlist.</div> : (
        <div className="space-y-3">
          {groups.map((g) => (
            <div key={g.product_id} data-testid={`waitlist-${g.article_code}`} className="border border-[color:var(--border)]">
              <div className="p-4 flex items-center justify-between flex-wrap gap-3">
                <div>
                  <div className="text-[10px] tracking-widest text-neutral-500">{g.article_code}</div>
                  <div className="display text-2xl">{g.product_name}</div>
                  <div className="text-xs text-neutral-400 mt-1">{g.count} subscribers · {g.notified} sudah dinotifikasi</div>
                </div>
                <div className="flex gap-2">
                  <button data-testid={`toggle-${g.article_code}`} onClick={() => setOpen(open === g.product_id ? null : g.product_id)} className="border border-white px-4 py-2 text-xs tracking-widest">
                    {open === g.product_id ? "TUTUP" : "LIHAT EMAIL"}
                  </button>
                  <button data-testid={`notify-${g.article_code}`} onClick={() => notify(g.product_id)} className="bg-white text-black px-4 py-2 text-xs tracking-widest">NOTIFIKASI DROP</button>
                </div>
              </div>
              {open === g.product_id && (
                <div className="border-t border-[color:var(--border)]">
                  <table className="w-full text-xs">
                    <thead className="text-[10px] tracking-widest text-neutral-500">
                      <tr className="border-b border-[color:var(--border)]"><th className="p-3 text-left">EMAIL</th><th className="p-3 text-left">SIGNED UP</th><th className="p-3 text-left">STATUS</th></tr>
                    </thead>
                    <tbody>{g.subscribers.map((s, i) => (
                      <tr key={i} className="border-b border-[color:var(--border)]">
                        <td className="p-3 mono">{s.email}</td>
                        <td className="p-3">{(s.created_at || "").slice(0, 10)}</td>
                        <td className="p-3"><span className="status-badge">{s.notified ? "NOTIFIED" : "PENDING"}</span></td>
                      </tr>
                    ))}</tbody>
                  </table>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
